(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ls-collection-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var desktopQuery = window.matchMedia('(min-width: 1024px)');

    function hydrateVideo(video) {
      if (!video || video.dataset.lsCollectionBannerLoaded === 'true') return;

      video.querySelectorAll('source[data-src]').forEach(function (source) {
        source.setAttribute('src', source.dataset.src);
        source.removeAttribute('data-src');
      });

      video.dataset.lsCollectionBannerLoaded = 'true';
      video.load();
    }

    function markVideoReady(video) {
      video.classList.add('ls-collection-banner__video--ready');
    }

    function syncSectionVideo(section) {
      if (!section) return;

      var activeViewport = desktopQuery.matches ? 'desktop' : 'mobile';

      section.querySelectorAll('[data-ls-collection-banner-video]').forEach(function (video) {
        var isActive = video.dataset.lsCollectionBannerVideo === activeViewport;

        if (!isActive) {
          video.pause();
          return;
        }

        hydrateVideo(video);

        if (video.readyState >= 2) {
          markVideoReady(video);
        } else {
          video.addEventListener('loadeddata', function () {
            markVideoReady(video);
          }, { once: true });
        }

        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      });
    }

    function syncAllSections() {
      document.querySelectorAll('[data-ls-collection-banner]').forEach(syncSectionVideo);
    }

    function initializeSection(section) {
      if (!section || section.dataset.lsCollectionBannerReady === 'true') return;
      section.dataset.lsCollectionBannerReady = 'true';
      syncSectionVideo(section);
    }

    function initializeAll(root) {
      if (!root) return;

      if (root.nodeType === 1 && root.matches('[data-ls-collection-banner]')) {
        initializeSection(root);
      }

      if (typeof root.querySelectorAll === 'function') {
        root.querySelectorAll('[data-ls-collection-banner]').forEach(initializeSection);
      }
    }

    function addMediaQueryListener(query, callback) {
      if (typeof query.addEventListener === 'function') {
        query.addEventListener('change', callback);
      } else if (typeof query.addListener === 'function') {
        query.addListener(callback);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAll(document);
      });
    } else {
      initializeAll(document);
    }

    addMediaQueryListener(desktopQuery, syncAllSections);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        document.querySelectorAll('[data-ls-collection-banner-video]').forEach(function (video) {
          video.pause();
        });
      } else {
        syncAllSections();
      }
    });

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-collection-info"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Fallback only — the real limit comes from the section's word-limit setting.
    var DESCRIPTION_WORD_LIMIT = 55;

    function countWords(text) {
      var words = text.trim().match(/\S+/g);
      return words ? words.length : 0;
    }

    function trimBlockToWordLimit(block, wordLimit) {
      var walker = document.createTreeWalker(block, window.NodeFilter.SHOW_TEXT);
      var textNodes = [];
      var node;
      var remainingWords = wordLimit;

      while ((node = walker.nextNode())) {
        textNodes.push(node);
      }

      for (var nodeIndex = 0; nodeIndex < textNodes.length; nodeIndex += 1) {
        var textNode = textNodes[nodeIndex];
        var text = textNode.nodeValue;
        var textWordCount = countWords(text);

        if (textWordCount === 0) continue;

        if (textWordCount < remainingWords) {
          remainingWords -= textWordCount;
          continue;
        }

        var wordPattern = /\S+/g;
        var match;
        var lastWordEnd = 0;
        var matchedWords = 0;

        while ((match = wordPattern.exec(text)) && matchedWords < remainingWords) {
          lastWordEnd = match.index + match[0].length;
          matchedWords += 1;
        }

        var trailingContent = document.createRange();
        trailingContent.setStart(textNode, lastWordEnd);
        trailingContent.setEnd(block, block.childNodes.length);
        trailingContent.deleteContents();
        return;
      }
    }

    function createDescriptionExcerpt(richText, wordLimit) {
      var excerpt = richText.cloneNode(true);
      var contentBlocks = Array.prototype.slice.call(excerpt.children).filter(function (block) {
        if (block.textContent.trim() !== '') return true;

        block.remove();
        return false;
      });
      var visibleWordCount = 0;
      var hasHiddenContent = false;

      if (contentBlocks.length === 0 && countWords(excerpt.textContent) > wordLimit) {
        trimBlockToWordLimit(excerpt, wordLimit);
        hasHiddenContent = true;
      }

      contentBlocks.forEach(function (block, index) {
        if (hasHiddenContent) return;

        var blockWordCount = countWords(block.textContent);
        var exceedsLimit = visibleWordCount + blockWordCount > wordLimit;

        if (!exceedsLimit) {
          visibleWordCount += blockWordCount;
          return;
        }

        hasHiddenContent = true;

        // Trim the overflowing block to the words still left in the budget, so the
        // limit is honoured exactly instead of snapping back to the previous block.
        var remainingWords = wordLimit - visibleWordCount;

        if (remainingWords > 0) {
          trimBlockToWordLimit(block, remainingWords);
          visibleWordCount = wordLimit;
          index += 1;
        }

        contentBlocks.slice(index).forEach(function (hiddenBlock) {
          hiddenBlock.remove();
        });
      });

      if (!hasHiddenContent) return null;

      excerpt.removeAttribute('id');
      excerpt.removeAttribute('data-ls-collection-info-copy');
      excerpt.querySelectorAll('[id]').forEach(function (element) {
        element.removeAttribute('id');
      });
      excerpt.classList.add('ls-collection-info__description-excerpt');

      return excerpt;
    }

    function prepareDescription(section) {
      var copy = section.querySelector('[data-ls-collection-info-copy]');
      var toggle = section.querySelector('[data-ls-collection-info-toggle]');
      if (!copy || !toggle) return;

      var wordLimit = parseInt(section.dataset.descriptionWordLimit, 10) || DESCRIPTION_WORD_LIMIT;
      var richText = copy.querySelector('.metafield-rich_text_field') || copy;
      var excerpt = createDescriptionExcerpt(richText, wordLimit);

      if (!excerpt) {
        toggle.hidden = true;
        return;
      }

      richText.classList.add('ls-collection-info__description-full');
      richText.parentNode.insertBefore(excerpt, richText);
      toggle.hidden = false;
    }

    function setHotspotCardDirection(point) {
      var button = point.querySelector('.oa-whats-on-them__button');
      var card = point.querySelector('.oa-whats-on-them__card');
      var look = point.closest('.ls-collection-info__look');
      var isMobile = window.matchMedia('(max-width: 1023px)').matches;

      if (!button || !card) return;

      var buttonBounds = button.getBoundingClientRect();
      var buttonCenter = buttonBounds.left + (buttonBounds.width / 2);
      var cardSpace = card.offsetWidth + 10 + (buttonBounds.width / 2) + 8;
      var spaceToLeft = buttonCenter;
      var spaceToRight = window.innerWidth - buttonCenter;
      var pointProperty = isMobile ? '--point-x-mobile' : '--point-x-desktop';
      var pointPosition = parseFloat(window.getComputedStyle(point).getPropertyValue(pointProperty));
      var preferredDirection;

      if (pointPosition < 50) {
        preferredDirection = 'right';
      } else if (pointPosition > 50) {
        preferredDirection = 'left';
      } else {
        preferredDirection = look && look.classList.contains('ls-collection-info__look--right') ? 'left' : 'right';
      }

      if (preferredDirection === 'right' && spaceToRight < cardSpace && spaceToLeft >= cardSpace) {
        preferredDirection = 'left';
      } else if (preferredDirection === 'left' && spaceToLeft < cardSpace && spaceToRight >= cardSpace) {
        preferredDirection = 'right';
      } else if (spaceToLeft < cardSpace && spaceToRight < cardSpace) {
        preferredDirection = spaceToRight >= spaceToLeft ? 'right' : 'left';
      }

      card.style.setProperty('--ls-hotspot-card-offset-x', '0px');
      card.style.setProperty('--ls-hotspot-card-offset-y', '0px');

      if (isMobile) {
        point.dataset.positionMobile = preferredDirection;
      } else {
        point.dataset.position = preferredDirection;
        point.classList.toggle('oa-whats-on-them__point--left', preferredDirection === 'left');
      }
    }

    function keepHotspotCardInViewport(point) {
      var card = point.querySelector('.oa-whats-on-them__card');
      if (!card) return;

      card.style.setProperty('--ls-hotspot-card-offset-x', '0px');
      card.style.setProperty('--ls-hotspot-card-offset-y', '0px');

      var cardBounds = card.getBoundingClientRect();
      var viewportGutter = 8;
      var horizontalOffset = 0;
      var verticalOffset = 0;

      if (cardBounds.left < viewportGutter) {
        horizontalOffset = viewportGutter - cardBounds.left;
      } else if (cardBounds.right > window.innerWidth - viewportGutter) {
        horizontalOffset = (window.innerWidth - viewportGutter) - cardBounds.right;
      }

      if (cardBounds.top < viewportGutter) {
        verticalOffset = viewportGutter - cardBounds.top;
      } else if (cardBounds.bottom > window.innerHeight - viewportGutter) {
        verticalOffset = (window.innerHeight - viewportGutter) - cardBounds.bottom;
      }

      card.style.setProperty('--ls-hotspot-card-offset-x', horizontalOffset + 'px');
      card.style.setProperty('--ls-hotspot-card-offset-y', verticalOffset + 'px');
    }

    function closeHotspots(section, exceptPoint) {
      section.querySelectorAll('[data-hotspot-point]').forEach(function (point) {
        if (point === exceptPoint) return;

        point.classList.remove('is-active');
        var button = point.querySelector('.oa-whats-on-them__button');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }

    function openHotspotProductPage(cardLink) {
      if (!cardLink) return;

      if (cardLink.tagName === 'A' && cardLink.getAttribute('href')) {
        window.location.href = cardLink.getAttribute('href');
        return;
      }

      var handle = cardLink.getAttribute('data-handle');
      if (!handle) return;

      var variantId = cardLink.getAttribute('data-variant-id');
      var href = '/products/' + handle;
      if (variantId) href += '?variant=' + variantId;
      window.location.href = href;
    }

    function initializeHotspots(section) {
      var resizeFrame;

      function repositionActiveHotspots() {
        section.querySelectorAll('[data-hotspot-point].is-active').forEach(function (point) {
          setHotspotCardDirection(point);
          keepHotspotCardInViewport(point);
        });
      }

      function handleViewportResize() {
        if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(repositionActiveHotspots);
      }

      function removeHotspotResizeListener(event) {
        if (!event.target.contains(section)) return;
        if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
        window.removeEventListener('resize', handleViewportResize);
        document.removeEventListener('shopify:section:unload', removeHotspotResizeListener);
      }

      section.addEventListener('click', function (event) {
        var cardLink = event.target.closest('.oa-whats-on-them__card-link');

        if (cardLink && section.contains(cardLink)) {
          /* Anchor links navigate to PDP naturally; buttons need a redirect. */
          if (cardLink.tagName !== 'A') {
            event.preventDefault();
            event.stopPropagation();
            openHotspotProductPage(cardLink);
          }
          closeHotspots(section);
          return;
        }

        var button = event.target.closest('.oa-whats-on-them__button');

        if (button && section.contains(button)) {
          event.preventDefault();
          event.stopPropagation();

          var point = button.closest('[data-hotspot-point]');
          var isMobile = window.matchMedia('(max-width: 1023px)').matches;

          if (isMobile) {
            closeHotspots(section);
            openHotspotProductPage(point.querySelector('.oa-whats-on-them__card-link'));
            return;
          }

          var isActive = point.classList.contains('is-active');
          closeHotspots(section, point);

          if (!isActive) setHotspotCardDirection(point);

          point.classList.toggle('is-active', !isActive);
          button.setAttribute('aria-expanded', isActive ? 'false' : 'true');

          if (!isActive) {
            window.requestAnimationFrame(function () {
              keepHotspotCardInViewport(point);
            });
          }
          return;
        }

        closeHotspots(section);
      });

      section.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeHotspots(section);
      });

      section.querySelectorAll('[data-hotspot-point]').forEach(setHotspotCardDirection);
      window.addEventListener('resize', handleViewportResize);
      document.addEventListener('shopify:section:unload', removeHotspotResizeListener);

    }

    function initializeCollectionInfo(section) {
      if (!section || section.dataset.lsCollectionInfoReady === 'true') return;

      var toggle = section.querySelector('[data-ls-collection-info-toggle]');
      section.dataset.lsCollectionInfoReady = 'true';

      if (toggle) {
        toggle.addEventListener('click', function () {
          var expanded = section.dataset.expanded === 'true';
          section.dataset.expanded = expanded ? 'false' : 'true';
          toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          toggle.textContent = expanded ? toggle.dataset.readMoreLabel : toggle.dataset.readLessLabel;
        });

        prepareDescription(section);
      }

      initializeHotspots(section);
    }

    function initializeCollectionInfos(root) {
      if (!root) return;

      if (root.nodeType === 1 && root.matches('[data-ls-collection-info]')) {
        initializeCollectionInfo(root);
      }

      if (typeof root.querySelectorAll === 'function') {
        root.querySelectorAll('[data-ls-collection-info]').forEach(initializeCollectionInfo);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeCollectionInfos(document);
      });
    } else {
      initializeCollectionInfos(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeCollectionInfos(event.target);
    });

    document.addEventListener('click', function (event) {
      document.querySelectorAll('[data-ls-collection-info]').forEach(function (section) {
        if (!section.contains(event.target)) closeHotspots(section);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-founder-quote"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DESKTOP_MQ = '(min-width: 1024px)';
    var REDUCED_MOTION_MQ = '(prefers-reduced-motion: reduce)';

    function initFounderQuote(root) {
      if (!root || root.dataset.lsFounderQuoteReady === 'true') return;
      root.dataset.lsFounderQuoteReady = 'true';

      var playBtn = root.querySelector('[data-ls-founder-quote-play]');
      var closeBtn = root.querySelector('[data-ls-founder-quote-close]');
      var teaserStage = root.querySelector('[data-ls-founder-quote-stage="teaser"]');
      var playerStage = root.querySelector('[data-ls-founder-quote-stage="player"]');
      if (!playBtn || !playerStage) return;

      var sectionShell = root.closest('.ls-founder-quote-section') || root;
      var desktopQuery = window.matchMedia(DESKTOP_MQ);
      var reducedMotionQuery = window.matchMedia(REDUCED_MOTION_MQ);
      var previewVideos = playBtn.querySelectorAll('.ls-founder-quote__video-thumb-video');
      var playerVideos = playerStage.querySelectorAll('.ls-founder-quote__player-video');

      function isDesktopVideo(video) {
        return video.classList.contains('ls-founder-quote__video-thumb-video--desktop')
          || video.classList.contains('ls-founder-quote__player-video--desktop');
      }

      function isMobileVideo(video) {
        return video.classList.contains('ls-founder-quote__video-thumb-video--mobile')
          || video.classList.contains('ls-founder-quote__player-video--mobile');
      }

      function getActiveVideo(videos) {
        if (!videos || !videos.length) return null;
        if (videos.length === 1) return videos[0];

        var active = null;
        Array.prototype.forEach.call(videos, function (video) {
          var match = desktopQuery.matches ? isDesktopVideo(video) : isMobileVideo(video);
          if (match) active = video;
        });
        return active || videos[0];
      }

      function pauseAll(videos) {
        Array.prototype.forEach.call(videos, function (video) {
          video.pause();
        });
      }

      function resetVideos(videos) {
        Array.prototype.forEach.call(videos, function (video) {
          video.pause();
          try {
            video.currentTime = 0;
          } catch (e) {}
        });
      }

      function tryPlay(video) {
        if (!video || typeof video.play !== 'function') return;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }

      function syncPreviewVideos() {
        pauseAll(previewVideos);
        if (reducedMotionQuery.matches) return;
        tryPlay(getActiveVideo(previewVideos));
      }

      function isPlaying() {
        return root.classList.contains('ls-founder-quote--playing');
      }

      function openPlayer() {
        var footprint = Math.round(sectionShell.getBoundingClientRect().height);
        sectionShell.style.height = footprint + 'px';
        root.style.height = '100%';
        root.classList.add('ls-founder-quote--playing');
        playerStage.setAttribute('aria-hidden', 'false');
        if (teaserStage) {
          teaserStage.setAttribute('aria-hidden', 'true');
          if ('inert' in teaserStage) teaserStage.inert = true;
        }

        pauseAll(previewVideos);
        tryPlay(getActiveVideo(playerVideos));
        if (closeBtn) closeBtn.focus();
      }

      function closePlayer() {
        if (!isPlaying()) return;

        root.classList.remove('ls-founder-quote--playing');
        playerStage.setAttribute('aria-hidden', 'true');
        if (teaserStage) {
          teaserStage.setAttribute('aria-hidden', 'false');
          if ('inert' in teaserStage) teaserStage.inert = false;
        }

        resetVideos(playerVideos);
        sectionShell.style.height = '';
        root.style.height = '';
        syncPreviewVideos();
        playBtn.focus();
      }

      playBtn.addEventListener('click', openPlayer);

      if (closeBtn) {
        closeBtn.addEventListener('click', closePlayer);
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isPlaying()) {
          closePlayer();
        }
      });

      Array.prototype.forEach.call(playerVideos, function (video) {
        video.addEventListener('ended', closePlayer);
      });

      function onBreakpointChange() {
        if (isPlaying()) {
          pauseAll(playerVideos);
          tryPlay(getActiveVideo(playerVideos));
          return;
        }
        syncPreviewVideos();
      }

      if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', onBreakpointChange);
      } else if (typeof desktopQuery.addListener === 'function') {
        desktopQuery.addListener(onBreakpointChange);
      }

      if (typeof reducedMotionQuery.addEventListener === 'function') {
        reducedMotionQuery.addEventListener('change', syncPreviewVideos);
      } else if (typeof reducedMotionQuery.addListener === 'function') {
        reducedMotionQuery.addListener(syncPreviewVideos);
      }

      syncPreviewVideos();
    }

    function initAll(scope) {
      if (!scope) return;
      if (scope.nodeType === 1 && scope.matches && scope.matches('[data-ls-founder-quote]')) {
        initFounderQuote(scope);
      }
      if (typeof scope.querySelectorAll === 'function') {
        Array.prototype.forEach.call(scope.querySelectorAll('[data-ls-founder-quote]'), initFounderQuote);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var PRODUCT_LIMIT = 5;
    var TILE_LIMIT = 6;
    var SEARCH_LIMIT = 60;

    // Coarse upper bound used until the grid has laid out, deliberately wider than the widest
    // real slot so replacing it with the measured width never asks for a larger candidate.
    var FALLBACK_IMAGE_SIZES = '(min-width: 1024px) 33vw, 62vw';

    function parseConfig(section) {
      var configElement = section.querySelector('[data-ls-product-grid-config]');

      if (!configElement) return null;

      try {
        return JSON.parse(configElement.textContent);
      } catch (error) {
        console.error('LS Product Grid: invalid section configuration.', error);
        return null;
      }
    }

    function isTruthyAvailability(value) {
      return value === true || value === 1 || value === 'true' || value === '1';
    }

    function isProductAvailable(product) {
      return product && (
        isTruthyAvailability(product.available)
        || isTruthyAvailability(product.inventory_available)
      );
    }

    function uniqueAvailableProducts(products) {
      var seen = new Set();

      return (products || []).filter(function (product) {
        if (!isProductAvailable(product)) return false;

        var key = product.handle || product.id || product.objectID;
        if (!key || seen.has(key)) return false;

        seen.add(key);
        return true;
      });
    }

    function interleaveProductGroups(groups, limit) {
      var positions = (groups || []).map(function () { return 0; });
      var products = [];
      var seen = new Set();
      var addedProduct = true;

      while (products.length < limit && addedProduct) {
        addedProduct = false;

        (groups || []).forEach(function (group, groupIndex) {
          if (products.length >= limit) return;

          while (positions[groupIndex] < (group || []).length) {
            var product = group[positions[groupIndex]];
            positions[groupIndex] += 1;

            if (!isProductAvailable(product)) continue;

            var key = product.handle || product.id || product.objectID;
            if (!key || seen.has(key)) continue;

            seen.add(key);
            products.push(product);
            addedProduct = true;
            break;
          }
        });
      }

      return products;
    }

    async function applyProjectTransforms(response) {
      var transformedResponse = response;

      if (typeof window.transformAppAlgoliaSearchResponse === 'function') {
        transformedResponse = await Promise.resolve(
          window.transformAppAlgoliaSearchResponse(transformedResponse)
        );
      }

      if (typeof window.transformPreviewLaunchTagAlgoliaSearchResponse === 'function') {
        transformedResponse = await Promise.resolve(
          window.transformPreviewLaunchTagAlgoliaSearchResponse(transformedResponse)
        );
      }

      return transformedResponse;
    }

    function initializeSection(section) {
      if (!section || section.__lsProductGridApp) return;

      var mountElement = section.querySelector('[data-ls-product-grid-app]');
      var config = parseConfig(section);

      if (!mountElement || !config || !window.Vue || !window.OAAlgoliaApi) return;

      var filters = (config.filters || []).filter(function (filter) {
        return filter && filter.id && filter.label && filter.facetValue;
      });

      var client = window.OAAlgoliaApi.getClient(config.appId, config.apiKey);

      section.__lsProductGridApp = new window.Vue({
        el: mountElement,
        delimiters: window.vueDelimiters || ['[', ']'],
        data: {
          activeFilterId: 'all',
          cache: {},
          cardWidths: [],
          filterAvailability: {},
          filterAvailabilityReady: false,
          filters: filters,
          loading: true,
          productLimit: TILE_LIMIT,
          products: [],
          requestSequence: 0,
          secondaryImageRequests: {},
          secondaryImages: {},
          statusMessage: config.emptyMessage || ''
        },
        computed: {
          productTiles: function () {
            var tiles = [];
            var firstProduct = this.products[0];

            if (firstProduct) {
              tiles.push({ key: 'product-' + this.productKey(firstProduct), product: firstProduct, type: 'product' });
              tiles.push({ key: 'secondary-' + this.productKey(firstProduct), product: firstProduct, type: 'secondary' });
            }

            this.products.slice(1, PRODUCT_LIMIT).forEach(function (product) {
              tiles.push({ key: 'product-' + this.productKey(product), product: product, type: 'product' });
            }, this);

            return tiles;
          }
        },
        mounted: function () {
          // The skeletons already sit in the six grid positions, so the real slot widths are
          // available before the first product image exists.
          this.$nextTick(this.measureCards);
          this.observeCardWidths();
          this.loadFilterAvailability();
          this.loadProducts();
        },
        updated: function () {
          this.measureCards();
        },
        beforeDestroy: function () {
          if (this._cardObserver) this._cardObserver.disconnect();
        },
        methods: {
          getActiveFilter: function () {
            if (this.activeFilterId === 'all') return null;

            return this.filters.find(function (filter) {
              return filter.id === this.activeFilterId;
            }, this) || null;
          },

          quoteFilterValue: function (value) {
            return window.OAAlgoliaApi.filters.quote(String(value));
          },

          algoliaFacetName: function () {
            return String(config.facetName || 'collections').trim() || 'collections';
          },

          facetFilter: function (value) {
            return window.OAAlgoliaApi.filters.facetFilter(
              this.algoliaFacetName(),
              this.quoteFilterValue(value)
            );
          },

          availabilityFilter: function () {
            return window.OAAlgoliaApi.filters.booleanFilter(
              'inventory_available',
              true
            );
          },

          filterExpressionForFacet: function (value) {
            return window.OAAlgoliaApi.filters.and([
              this.facetFilter(value),
              this.availabilityFilter()
            ]);
          },

          allFacetValue: function () {
            return String(config.allFacetValue || '').trim();
          },

          usesDedicatedAllFacet: function () {
            return Boolean(this.allFacetValue());
          },

          usesBalancedAllResults: function () {
            return !this.getActiveFilter()
              && this.filters.length > 0
              && !this.usesDedicatedAllFacet();
          },

          ruleContextValue: function (value) {
            return String(value || '')
              .normalize('NFKD')
              .replace(/[\u0300-\u036f]/g, '')
              .replace(/[^a-zA-Z0-9_-]+/g, '-')
              .replace(/^-+|-+$/g, '');
          },

          getFilterExpression: function () {
            var activeFilter = this.getActiveFilter();
            var allFacetValue = this.allFacetValue();

            if (activeFilter) {
              return this.filterExpressionForFacet(activeFilter.facetValue);
            }

            if (allFacetValue) {
              return this.filterExpressionForFacet(allFacetValue);
            }

            if (this.filters.length === 0) return this.availabilityFilter();

            return window.OAAlgoliaApi.filters.and([
              window.OAAlgoliaApi.filters.group(
                window.OAAlgoliaApi.filters.or(
                  this.filters.map(function (filter) {
                    return this.facetFilter(filter.facetValue);
                  }, this)
                )
              ),
              this.availabilityFilter()
            ]);
          },

          isFilterVisible: function (filterId) {
            if (!this.filterAvailabilityReady) return false;

            if (filterId === 'all') {
              if (this.usesDedicatedAllFacet() && this.filterAvailability.all === true) {
                return true;
              }

              if (this.filters.length === 0) return this.products.length > 0;

              return this.filters.some(function (filter) {
                return this.filterAvailability[filter.id] === true;
              }, this);
            }

            return this.filterAvailability[filterId] === true;
          },

          productKey: function (product) {
            return String(product && (product.objectID || product.id || product.handle) || '');
          },

          productUrl: function (product) {
            var shopUrl = window.Shopify ? window.Shopify.shop_url : '';
            return shopUrl + '/products/' + product.handle;
          },

          resizeImage: function (imageUrl, size) {
            if (typeof window.OAImageSrc !== 'function') return imageUrl || '';

            return window.OAImageSrc(imageUrl, size);
          },

          secondaryImageFor: function (product) {
            return this.secondaryImages[String(product.id)] || '';
          },

          secondaryImageSrcSet: function (product) {
            // A missing helper costs the srcset, not the tile - the src fallback still renders.
            if (typeof window.OAImageSrcSet !== 'function') return '';

            return window.OAImageSrcSet(this.secondaryImageFor(product));
          },

          cardImageSizes: function (index) {
            var width = this.cardWidths[index];
            return width ? width + 'px' : FALLBACK_IMAGE_SIZES;
          },

          // The CSS is the only source of truth for the six card widths - read them off the
          // laid-out grid rather than restating the nth-child rules here.
          measureCards: function () {
            var grid = this.$el.querySelector('.ls-product-grid__products');
            if (!grid) return;

            var widths = Array.prototype.map.call(grid.children, function (card) {
              return Math.round(card.getBoundingClientRect().width);
            });

            // A zero means the section is hidden; keep the last good measurement.
            if (widths.length === 0 || widths.indexOf(0) !== -1) return;
            if (widths.join() === this.cardWidths.join()) return;

            this.cardWidths = widths;
          },

          observeCardWidths: function () {
            if (typeof window.ResizeObserver !== 'function') return;

            var grid = this.$el.querySelector('.ls-product-grid__products');
            if (!grid) return;

            var self = this;
            this._cardObserver = new window.ResizeObserver(function () {
              self.measureCards();
            });
            this._cardObserver.observe(grid);
          },

          preloadSecondaryImages: function (products) {
            if (!window.OAProductsApi || typeof window.OAProductsApi.fetchByIds !== 'function') {
              return Promise.resolve();
            }

            var seen = new Set();
            var productsToLoad = (products || []).filter(function (product) {
              var id = product && String(product.id || '');

              if (!id || seen.has(id) || this.secondaryImages[id] || this.secondaryImageRequests[id]) {
                return false;
              }

              seen.add(id);
              this.$set(this.secondaryImageRequests, id, true);
              return true;
            }, this);

            if (productsToLoad.length === 0) return Promise.resolve();

            var ids = productsToLoad.map(function (product) { return product.id; });

            return window.OAProductsApi.fetchByIds(ids).then(function (productDetails) {
              (productDetails || []).forEach(function (productDetail, index) {
                var images = productDetail && productDetail.images ? productDetail.images : [];
                var secondImage = images[1] || images[0];
                var imageUrl = typeof secondImage === 'object'
                  ? secondImage.src || secondImage.url
                  : secondImage;

                if (imageUrl) {
                  this.$set(this.secondaryImages, String(ids[index]), imageUrl);
                }
              }, this);
            }.bind(this)).catch(function (error) {
              console.error('LS Product Grid: unable to preload secondary product images.', error);
            }).finally(function () {
              ids.forEach(function (id) {
                this.$delete(this.secondaryImageRequests, String(id));
              }, this);
            }.bind(this));
          },

          cacheFilterResults: function (results, preserveExisting) {
            var productsToEnrich = [];

            this.filters.forEach(function (filter, index) {
              var result = results[index];
              var products = uniqueAvailableProducts(result && result.hits ? result.hits : [])
                .slice(0, PRODUCT_LIMIT);

              if (products.length === 0) return;

              if (!preserveExisting || !this.cache[filter.id] || this.cache[filter.id].length === 0) {
                this.$set(this.cache, filter.id, products);
              }

              if (this.cache[filter.id][0]) {
                productsToEnrich.push(this.cache[filter.id][0]);
              }
            }, this);

            this.preloadSecondaryImages(productsToEnrich);
          },

          updateSectionVisibility: function () {
            if (!this.filterAvailabilityReady || this.loading) return;

            var hasAvailableFilter = this.filters.some(function (filter) {
              return this.filterAvailability[filter.id] === true;
            }, this) || this.filterAvailability.all === true;
            var hasCachedProducts = Object.keys(this.cache).some(function (key) {
              return Array.isArray(this.cache[key]) && this.cache[key].length > 0;
            }, this);

            section.hidden = !config.designMode
              && !(hasAvailableFilter || hasCachedProducts || this.products.length > 0);
          },

          loadFilterAvailability: async function () {
            var allFacetValue = this.allFacetValue();

            if (this.filters.length === 0 && !allFacetValue) {
              this.filterAvailabilityReady = true;
              this.$nextTick(this.updateSectionVisibility);
              return;
            }

            try {
              var requests = this.filters.map(function (filter) {
                var ruleContexts = this.getRuleContexts(filter);
                var request = {
                  indexName: config.indexName,
                  query: '',
                  filters: this.filterExpressionForFacet(filter.facetValue),
                  attributesToHighlight: [],
                  attributesToSnippet: [],
                  hitsPerPage: PRODUCT_LIMIT,
                  analytics: false,
                  clickAnalytics: false
                };

                if (ruleContexts.length > 0) request.ruleContexts = ruleContexts;

                return request;
              }, this);

              if (allFacetValue) {
                var allRuleContexts = this.getRuleContexts(null);
                var allRequest = {
                  indexName: config.indexName,
                  query: '',
                  filters: this.filterExpressionForFacet(allFacetValue),
                  attributesToHighlight: [],
                  attributesToSnippet: [],
                  hitsPerPage: PRODUCT_LIMIT,
                  analytics: false,
                  clickAnalytics: false
                };

                if (allRuleContexts.length > 0) allRequest.ruleContexts = allRuleContexts;

                requests.push(allRequest);
              }

              var response = await client.search({ requests: requests });
              var transformedResponse = await applyProjectTransforms(response);
              var results = transformedResponse && transformedResponse.results
                ? transformedResponse.results
                : [];

              this.cacheFilterResults(results.slice(0, this.filters.length), true);

              this.filters.forEach(function (filter, index) {
                var result = results[index];
                var hasProducts = uniqueAvailableProducts(result && result.hits ? result.hits : []).length > 0;

                this.$set(this.filterAvailability, filter.id, hasProducts);
              }, this);

              if (allFacetValue) {
                var allResult = results[this.filters.length];
                var allProducts = uniqueAvailableProducts(allResult && allResult.hits ? allResult.hits : [])
                  .slice(0, PRODUCT_LIMIT);

                this.$set(this.filterAvailability, 'all', allProducts.length > 0);

                if (allProducts.length > 0 && (!this.cache.all || this.cache.all.length === 0)) {
                  this.$set(this.cache, 'all', allProducts);
                  this.preloadSecondaryImages(allProducts.slice(0, 1));
                }
              }
            } catch (error) {
              console.error('LS Product Grid: unable to validate collection tabs.', error);

              this.filters.forEach(function (filter) {
                this.$set(this.filterAvailability, filter.id, false);
              }, this);

              if (allFacetValue) {
                this.$set(this.filterAvailability, 'all', false);
              }
            } finally {
              this.filterAvailabilityReady = true;
              this.$nextTick(this.updateSectionVisibility);
            }
          },

          getRuleContexts: function (activeFilter) {
            var contexts = [];
            var baseContext = this.ruleContextValue(config.ruleContext);

            if (baseContext) {
              contexts.push(baseContext);

              if (activeFilter) {
                var facetContext = this.ruleContextValue(activeFilter.facetValue);

                if (facetContext) {
                  var suffix = facetContext.indexOf(baseContext + '-') === 0
                    ? facetContext.slice(baseContext.length + 1)
                    : facetContext;
                  contexts.push(baseContext + '-' + suffix);
                }
              } else if (this.usesDedicatedAllFacet()) {
                contexts.push(baseContext + '-all');
              }
            }

            return contexts.filter(Boolean);
          },


          buildSearchRequest: function (activeFilter, hitsPerPage) {
            var request = {
              indexName: config.indexName,
              query: '',
              hitsPerPage: hitsPerPage
            };
            var filterExpression = activeFilter
              ? this.filterExpressionForFacet(activeFilter.facetValue)
              : this.getFilterExpression();
            var ruleContexts = this.getRuleContexts(activeFilter);

            if (filterExpression) request.filters = filterExpression;
            if (ruleContexts.length > 0) request.ruleContexts = ruleContexts;

            return request;
          },

          fetchProducts: async function () {
            var activeFilter = this.getActiveFilter();
            var usesBalancedResults = this.usesBalancedAllResults();
            var hitsPerFilter = usesBalancedResults
              ? Math.max(PRODUCT_LIMIT, Math.ceil(SEARCH_LIMIT / this.filters.length))
              : SEARCH_LIMIT;
            var requests = usesBalancedResults
              ? this.filters.map(function (filter) {
                  return this.buildSearchRequest(filter, hitsPerFilter);
                }, this)
              : [this.buildSearchRequest(activeFilter, hitsPerFilter)];
            var response = await client.search({ requests: requests });
            var transformedResponse = await applyProjectTransforms(response);
            var results = transformedResponse && transformedResponse.results
              ? transformedResponse.results
              : [];

            if (usesBalancedResults) {
              this.cacheFilterResults(results);

              return interleaveProductGroups(
                results.map(function (result) { return result.hits || []; }),
                SEARCH_LIMIT
              );
            }

            return results[0]
              ? results[0].hits || []
              : [];
          },

          refreshIntegrations: function () {
            this.$nextTick(function () {
              if (window.lazyLoadInstance && typeof window.lazyLoadInstance.update === 'function') {
                window.lazyLoadInstance.update();
              }

              if (typeof window.wishlistload === 'function') {
                window.wishlistload.init = false;
                window.wishlistload();
              }
            });
          },

          loadProducts: async function () {
            var cacheKey = this.activeFilterId;
            var requestId = ++this.requestSequence;

            if (this.cache[cacheKey]) {
              this.products = this.cache[cacheKey];
              this.loading = false;
              this.preloadSecondaryImages(this.products.slice(0, 1));
              this.refreshIntegrations();
              this.$nextTick(this.updateSectionVisibility);
              return;
            }

            this.loading = true;
            this.statusMessage = config.emptyMessage || '';

            try {
              var searchHits = await this.fetchProducts();
              var availableProducts = uniqueAvailableProducts(searchHits);

              if (requestId !== this.requestSequence) return;

              var visibleProducts = availableProducts.slice(0, PRODUCT_LIMIT);
              this.$set(this.cache, cacheKey, visibleProducts);
              this.products = visibleProducts;
              this.preloadSecondaryImages(visibleProducts.slice(0, 1));
              this.refreshIntegrations();
            } catch (error) {
              if (requestId !== this.requestSequence) return;
              console.error('LS Product Grid: unable to load products.', error);
              this.products = [];
            } finally {
              if (requestId === this.requestSequence) {
                this.loading = false;
                this.$nextTick(this.updateSectionVisibility);
              }
            }
          },

          selectFilter: function (filterId) {
            var nextFilterId = filterId || 'all';

            if (
              nextFilterId !== 'all'
              && !this.filters.some(function (filter) { return filter.id === nextFilterId; })
            ) {
              return;
            }

            if (this.filterAvailabilityReady && !this.isFilterVisible(nextFilterId)) return;

            if (this.activeFilterId === nextFilterId && this.products.length > 0) return;

            this.activeFilterId = nextFilterId;
            this.loadProducts();
          }
        }
      });
    }

    function initializeAll(root) {
      if (!root) return;

      if (root.nodeType === 1 && root.matches('[data-ls-product-grid]')) {
        initializeSection(root);
      }

      if (typeof root.querySelectorAll === 'function') {
        root.querySelectorAll('[data-ls-product-grid]').forEach(initializeSection);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAll(document);
      });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var section = event.target.matches('[data-ls-product-grid]')
        ? event.target
        : event.target.querySelector('[data-ls-product-grid]');

      if (section && section.__lsProductGridApp) {
        section.__lsProductGridApp.$destroy();
        section.__lsProductGridApp = null;
      }
    });

    document.addEventListener('shopify:block:select', function (event) {
      var section = event.target.closest('[data-ls-product-grid]');

      if (section && section.__lsProductGridApp && event.detail && event.detail.blockId) {
        section.__lsProductGridApp.selectFilter(event.detail.blockId);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-static-product-category"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sectionCleanups = new WeakMap();

    // The page-wide "Pause videos" in oa-a11y-controls.js, which may load after this runs.
    function motionPaused() {
      return !!(window.oaA11yControls && window.oaA11yControls.motion.paused());
    }

    function initializeSection(section) {
      if (!section || section.dataset.lsStaticReady === 'true') return;

      var backgrounds = Array.prototype.slice.call(section.querySelectorAll('[data-ls-static-bg]'));
      var labels = Array.prototype.slice.call(section.querySelectorAll('[data-ls-static-label]'));
      var labelsViewport = section.querySelector('[data-ls-static-labels-viewport]');
      var labelsTrack = section.querySelector('[data-ls-static-labels-track]');
      var pauseButton = section.querySelector('[data-ls-static-pause]');
      var desktopQuery = window.matchMedia('(min-width: 1024px)');
      var currentIndex = 0;
      var isPaused = false;
      var labelsResizeObserver = null;
      var headerResizeObserver = null;
      var labelEventHandlers = [];
      var pauseClickHandler = null;
      var usesWindowLabelResize = false;

      if (!backgrounds.length) return;
      section.dataset.lsStaticReady = 'true';

      function getSectionWrapper() {
        return section.closest('.ls-static-product-category-section') || section.parentElement;
      }

      function syncStickyOffset() {
        var wrapper = getSectionWrapper();
        if (!wrapper) return;

        if (!desktopQuery.matches) {
          wrapper.style.removeProperty('--ls-sticky-offset');
          return;
        }

        var header = document.getElementById('oa-hdr19');
        var offset = header ? Math.round(header.getBoundingClientRect().height) : 0;
        wrapper.style.setProperty('--ls-sticky-offset', offset + 'px');
      }

      function getLabelAlignment() {
        if (!labelsViewport) return 'left';
        if (labelsViewport.className.indexOf('--center') !== -1) return 'center';
        if (labelsViewport.className.indexOf('--right') !== -1) return 'right';
        return 'left';
      }

      function getGridMetrics() {
        var viewportStyles = getComputedStyle(labelsViewport);
        var margin = parseFloat(viewportStyles.paddingLeft) || 16;
        var gutter = parseFloat(viewportStyles.getPropertyValue('--ls-grid-gutter')) || 8;
        var columns = parseInt(viewportStyles.getPropertyValue('--ls-grid-columns'), 10) || 12;
        var viewportWidth = labelsViewport.clientWidth;
        var contentWidth = viewportWidth - margin * 2;
        var colWidth = (contentWidth - gutter * (columns - 1)) / columns;

        return {
          margin: margin,
          gutter: gutter,
          columns: columns,
          colWidth: colWidth
        };
      }

      function getGridColumnStart(columnIndex) {
        var grid = getGridMetrics();
        var index = Math.max(1, columnIndex) - 1;

        return grid.margin + index * (grid.colWidth + grid.gutter);
      }

      function getScrollAnchorColumn() {
        if (desktopQuery.matches) {
          return 1;
        }

        var anchorColumns = labelsViewport.getAttribute('data-scroll-anchors');

        if (anchorColumns) {
          var columns = anchorColumns.split(',').map(function (value) {
            return parseInt(value, 10);
          });

          if (columns[currentIndex]) {
            return columns[currentIndex];
          }
        }

        return 1;
      }

      function getLabelAnchorX() {
        if (!labelsViewport) return 16;

        var alignment = getLabelAlignment();

        if (alignment === 'center') {
          return labelsViewport.clientWidth / 2;
        }

        if (alignment === 'right') {
          var grid = getGridMetrics();
          return labelsViewport.clientWidth - grid.margin;
        }

        return getGridColumnStart(getScrollAnchorColumn());
      }

      function syncLabelScroll() {
        if (!labelsViewport || !labelsTrack || !labels.length) return;

        var activeLabel = labels[currentIndex];
        if (!activeLabel) return;

        var lastLabel = labels[labels.length - 1];
        var trackWidth = Math.max(
          labelsTrack.scrollWidth,
          lastLabel.offsetLeft + lastLabel.offsetWidth
        );
        var viewportStyles = getComputedStyle(labelsViewport);
        var viewportWidth = labelsViewport.clientWidth;
        var contentWidth =
          viewportWidth -
          (parseFloat(viewportStyles.paddingLeft) || 0) -
          (parseFloat(viewportStyles.paddingRight) || 0);
        var isOverflowing = trackWidth > contentWidth + 1;

        labelsViewport.classList.toggle('ls-static-product-category__labels-viewport--scrollable', isOverflowing);

        if (!isOverflowing) {
          labelsTrack.style.transform = '';
          return;
        }

        /* Overflowing: scroll active label into view (ignore left/center/right group alignment). */

        var labelLeft = activeLabel.offsetLeft;
        var labelWidth = activeLabel.offsetWidth;
        var trackOffset = labelsTrack.offsetLeft;
        var alignment = getLabelAlignment();
        var translateX;

        if (alignment === 'center') {
          translateX = (viewportWidth - labelWidth) / 2 - trackOffset - labelLeft;
        } else if (alignment === 'right') {
          var grid = getGridMetrics();
          translateX = viewportWidth - grid.margin - labelWidth - trackOffset - labelLeft;
        } else {
          translateX = getLabelAnchorX() - trackOffset - labelLeft;
          /* Mobile slide 2: nudge 8px left so the next tab peeks a bit more */
          if (!desktopQuery.matches && currentIndex === 1) {
            translateX -= 8;
          }
        }

        labelsTrack.style.transform = 'translateX(' + translateX + 'px)';
      }

      function activeVideo() {
        var bg = backgrounds[currentIndex];
        if (!bg) return null;
        var selector = desktopQuery.matches
          ? '.ls-static-product-category__background-video--desktop'
          : '.ls-static-product-category__background-video--mobile';
        return bg.querySelector(selector);
      }

      function hydrateMedia(background) {
        if (!background || background.dataset.lsMediaReady === 'true') return;

        background.querySelectorAll('img[data-src]').forEach(function (img) {
          if (img.dataset.srcset) {
            img.setAttribute('srcset', img.dataset.srcset);
            img.removeAttribute('data-srcset');
          }
          if (img.dataset.src) {
            img.setAttribute('src', img.dataset.src);
            img.removeAttribute('data-src');
          }
        });

        background.dataset.lsMediaReady = 'true';
      }

      function syncVideos() {
        var videoToPlay = activeVideo();
        var activeBackground = backgrounds[currentIndex];

        hydrateMedia(activeBackground);

        section.querySelectorAll('.ls-static-product-category__background-video').forEach(function (video) {
          if (video === videoToPlay && !isPaused) {
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
          } else {
            video.pause();
          }
        });

        if (pauseButton) {
          pauseButton.hidden = !videoToPlay;
          pauseButton.classList.toggle('ls-static-product-category__pause--paused', isPaused);
          pauseButton.setAttribute('aria-label', isPaused ? pauseButton.dataset.labelPlay : pauseButton.dataset.labelPause);
        }
      }

      function render(nextIndex) {
        currentIndex = (nextIndex + backgrounds.length) % backgrounds.length;
        isPaused = motionPaused();

        backgrounds.forEach(function (bg, i) {
          bg.classList.toggle('ls-static-product-category__background--active', i === currentIndex);
        });

        labels.forEach(function (label, i) {
          var active = i === currentIndex;
          label.classList.toggle('ls-static-product-category__label--active', active);
          label.setAttribute('aria-selected', active ? 'true' : 'false');
          label.setAttribute('tabindex', active ? '0' : '-1');
        });

        syncLabelScroll();
        syncVideos();
      }

      labels.forEach(function (label) {
        var clickHandler = function () {
          render(Number(label.dataset.slideIndex));
        };

        var keydownHandler = function (event) {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            event.preventDefault();
            render(currentIndex - 1);
            labels[currentIndex].focus();
          }
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            event.preventDefault();
            render(currentIndex + 1);
            labels[currentIndex].focus();
          }
        };

        label.addEventListener('click', clickHandler);
        label.addEventListener('keydown', keydownHandler);
        labelEventHandlers.push({
          label: label,
          click: clickHandler,
          keydown: keydownHandler
        });
      });

      if (pauseButton) {
        pauseClickHandler = function () {
          isPaused = !isPaused;
          if (!isPaused && window.oaA11yControls) window.oaA11yControls.motion.release(activeVideo());
          syncVideos();
        };
        pauseButton.addEventListener('click', pauseClickHandler);
      }

      function handleMotionChange(event) {
        isPaused = event.detail.paused;
        syncVideos();
      }

      document.addEventListener('oa:motionchange', handleMotionChange);

      function handleBreakpointChange() {
        isPaused = motionPaused();
        syncStickyOffset();
        syncLabelScroll();
        syncVideos();
      }

      if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', handleBreakpointChange);
      } else if (typeof desktopQuery.addListener === 'function') {
        desktopQuery.addListener(handleBreakpointChange);
      }

      if (labelsViewport && typeof ResizeObserver !== 'undefined') {
        labelsResizeObserver = new ResizeObserver(function () {
          syncLabelScroll();
        });
        labelsResizeObserver.observe(labelsViewport);
        labelsResizeObserver.observe(labelsTrack);
      } else {
        usesWindowLabelResize = true;
        window.addEventListener('resize', syncLabelScroll);
      }

      window.addEventListener('resize', syncStickyOffset);

      var headerEl = document.getElementById('oa-hdr19');
      if (headerEl && typeof ResizeObserver !== 'undefined') {
        headerResizeObserver = new ResizeObserver(function () {
          syncStickyOffset();
        });
        headerResizeObserver.observe(headerEl);
      }

      function handleVisibilityChange() {
        if (document.hidden) {
          section.querySelectorAll('.ls-static-product-category__background-video').forEach(function (video) {
            video.pause();
          });
        } else {
          syncVideos();
        }
      }

      document.addEventListener('visibilitychange', handleVisibilityChange);

      syncStickyOffset();
      render(0);

      sectionCleanups.set(section, function () {
        labelEventHandlers.forEach(function (handlers) {
          handlers.label.removeEventListener('click', handlers.click);
          handlers.label.removeEventListener('keydown', handlers.keydown);
        });

        if (pauseButton && pauseClickHandler) {
          pauseButton.removeEventListener('click', pauseClickHandler);
        }
        if (typeof desktopQuery.removeEventListener === 'function') {
          desktopQuery.removeEventListener('change', handleBreakpointChange);
        } else if (typeof desktopQuery.removeListener === 'function') {
          desktopQuery.removeListener(handleBreakpointChange);
        }
        if (labelsResizeObserver) {
          labelsResizeObserver.disconnect();
        }
        if (headerResizeObserver) {
          headerResizeObserver.disconnect();
        }
        if (usesWindowLabelResize) {
          window.removeEventListener('resize', syncLabelScroll);
        }

        window.removeEventListener('resize', syncStickyOffset);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        document.removeEventListener('oa:motionchange', handleMotionChange);

        section.querySelectorAll('.ls-static-product-category__background-video').forEach(function (video) {
          video.pause();
        });

        section.removeAttribute('data-ls-static-ready');
        sectionCleanups.delete(section);
      });
    }

    function cleanupSection(section) {
      var cleanup = sectionCleanups.get(section);
      if (cleanup) cleanup();
    }

    function initializeAll(root) {
      if (!root) return;
      if (root.nodeType === 1 && root.matches('[data-ls-static-product-category]')) {
        initializeSection(root);
      }
      if (typeof root.querySelectorAll === 'function') {
        root.querySelectorAll('[data-ls-static-product-category]').forEach(initializeSection);
      }
    }

    function cleanupAll(root) {
      if (!root) return;
      if (root.nodeType === 1 && root.matches('[data-ls-static-product-category]')) {
        cleanupSection(root);
      }
      if (typeof root.querySelectorAll === 'function') {
        root.querySelectorAll('[data-ls-static-product-category]').forEach(cleanupSection);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAll(document);
      });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      cleanupAll(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var blockId = event.detail.blockId;
      var section = event.target.closest('[data-ls-static-product-category]');
      if (!section) {
        section = event.target.querySelector('[data-ls-static-product-category]');
      }
      if (!section) return;
      var label = section.querySelector('[data-ls-static-label][data-block-id="' + blockId + '"]');
      if (label) label.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-three-tiles-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var carouselCleanups = new WeakMap();

    function initializeCarousel(section) {
      if (!section || section.dataset.lsThreeTilesReady === 'true') return;

      var slides = Array.prototype.slice.call(section.querySelectorAll('[data-ls-three-tiles-slide]'));
      var thumbnails = Array.prototype.slice.call(section.querySelectorAll('[data-ls-three-tiles-thumbnail]'));
      var thumbnailsContainer = section.querySelector('[data-ls-three-tiles-thumbnails]');
      var previousButtons = section.querySelectorAll('[data-ls-three-tiles-previous]');
      var nextButtons = section.querySelectorAll('[data-ls-three-tiles-next]');
      var mobileQuery = window.matchMedia('(max-width: 1023px)');
      var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      var currentIndex = 0;
      var transitionDuration = 300;
      var isInitialized = false;
      var isTransitioning = false;
      var queuedIndex = null;
      var transitionFrame = 0;
      var transitionInnerFrame = 0;
      var transitionTimer = 0;
      var eventCleanups = [];
      var touchStartX = 0;
      var touchStartY = 0;
      var isTrackingSwipe = false;

      if (!slides.length) return;
      section.dataset.lsThreeTilesReady = 'true';

      function listen(target, eventName, handler, options) {
        target.addEventListener(eventName, handler, options);
        eventCleanups.push(function () {
          target.removeEventListener(eventName, handler, options);
        });
      }

      function listenToMediaQuery(query, handler) {
        if (typeof query.addEventListener === 'function') {
          query.addEventListener('change', handler);
          eventCleanups.push(function () {
            query.removeEventListener('change', handler);
          });
        } else if (typeof query.addListener === 'function') {
          query.addListener(handler);
          eventCleanups.push(function () {
            query.removeListener(handler);
          });
        }
      }

    function paddedNumber(number) {
      return number < 10 ? '0' + number : String(number);
    }

    function activeVideo() {
      var activeSlide = slides[currentIndex];
      if (!activeSlide) return null;
      var selector = mobileQuery.matches
        ? '.ls-three-tiles-carousel__video--mobile'
        : '.ls-three-tiles-carousel__video--desktop';
      return activeSlide.querySelector(selector);
    }

    function setSlideProgress(slide, value, immediate) {
      if (!slide) return;
      var progress = slide.querySelector('[data-ls-three-tiles-progress]');
      if (!progress) return;
      var normalizedValue = Math.max(0, Math.min(value, 1));

      if (immediate) {
        progress.classList.add('ls-three-tiles-carousel__progress-value--immediate');
      }

      progress.style.transform = 'scaleX(' + normalizedValue + ')';
 
      if (immediate) {
        progress.offsetWidth;
        progress.classList.remove('ls-three-tiles-carousel__progress-value--immediate');
      }
    }

    function syncVideos(resetActiveVideo) {
      var currentVideo = activeVideo();

      section.querySelectorAll('.ls-three-tiles-carousel__video').forEach(function (video) {
        if (video === currentVideo) {
          if (resetActiveVideo) {
            if (video.readyState >= 1) {
              video.currentTime = 0;
            } else {
              video.dataset.lsThreeTilesReset = 'true';
            }
          }
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
        } else {
          video.pause();
        }
      });

    }

    function updateThumbnails() {
      thumbnails.forEach(function (thumbnail) {
        thumbnail.hidden = true;
        thumbnail.style.order = '';
      });

      var visibleThumbnails = [];
      var maxVisible = mobileQuery.matches ? slides.length - 1 : 2;

      for (var step = 1; step < slides.length && visibleThumbnails.length < maxVisible; step += 1) {
        var thumbnailIndex = (currentIndex + step) % slides.length;
        var thumbnail = thumbnails[thumbnailIndex];
        if (!thumbnail) continue;
        thumbnail.hidden = false;
        thumbnail.style.order = String(visibleThumbnails.length + 1);
        visibleThumbnails.push(thumbnail);
      }

      if (thumbnailsContainer) {
        var activePanel = slides[currentIndex].querySelector('.ls-three-tiles-carousel__panel');
        if (activePanel) activePanel.appendChild(thumbnailsContainer);
        thumbnailsContainer.classList.toggle('ls-three-tiles-carousel__thumbnails--single', visibleThumbnails.length === 1);

        var track = thumbnailsContainer.querySelector('.ls-three-tiles-carousel__thumbnails-track');
        if (track && mobileQuery.matches) {
          track.scrollLeft = 0;
        }
      }
    }

    function updateCurrentLabel() {
      slides[currentIndex].querySelectorAll('[data-ls-three-tiles-current]').forEach(function (label) {
        label.textContent = paddedNumber(currentIndex + 1);
      });
    }

    function createThumbnailsPlaceholder(panel) {
      if (!panel || !thumbnailsContainer || !thumbnailsContainer.parentNode) return null;

      var placeholder = thumbnailsContainer.cloneNode(true);
      placeholder.removeAttribute('data-ls-three-tiles-thumbnails');
      placeholder.classList.add('ls-three-tiles-carousel__thumbnails--placeholder');
      placeholder.setAttribute('aria-hidden', 'true');
      placeholder.querySelectorAll('[data-ls-three-tiles-thumbnail]').forEach(function (thumbnail) {
        thumbnail.removeAttribute('data-ls-three-tiles-thumbnail');
        thumbnail.setAttribute('tabindex', '-1');
      });
      panel.appendChild(placeholder);
      return placeholder;
    }

    function initialize(nextIndex) {
      currentIndex = nextIndex;

      slides.forEach(function (slide, index) {
        var active = index === currentIndex;
        var panel = slide.querySelector('.ls-three-tiles-carousel__panel');
        if (panel) panel.style.visibility = '';
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.classList.remove(
          'ls-three-tiles-carousel__slide--entering',
          'ls-three-tiles-carousel__slide--leaving',
          'ls-three-tiles-carousel__slide--visible'
        );
      });

      updateThumbnails();
      updateCurrentLabel();
      setSlideProgress(slides[currentIndex], (currentIndex + 1) / slides.length, true);
      syncVideos(true);
      isInitialized = true;
    }

    function render(nextIndex) {
      var normalizedIndex = (nextIndex + slides.length) % slides.length;

      if (!isInitialized) {
        initialize(normalizedIndex);
        return;
      }

      if (isTransitioning) {
        queuedIndex = normalizedIndex;
        return;
      }

      if (normalizedIndex === currentIndex) return;

      var previousIndex = currentIndex;
      var previousSlide = slides[previousIndex];
      var nextSlide = slides[normalizedIndex];
      var previousPanel = previousSlide.querySelector('.ls-three-tiles-carousel__panel');
      var nextPanel = nextSlide.querySelector('.ls-three-tiles-carousel__panel');
      var thumbnailsPlaceholder = createThumbnailsPlaceholder(previousPanel);
      var duration = reducedMotionQuery.matches ? 0 : transitionDuration;

      isTransitioning = true;
      currentIndex = normalizedIndex;

      if (previousPanel) previousPanel.style.visibility = 'hidden';
      if (nextPanel) nextPanel.style.visibility = '';
      nextSlide.hidden = false;
      nextSlide.setAttribute('aria-hidden', 'false');
      previousSlide.setAttribute('aria-hidden', 'true');
      nextSlide.classList.add('ls-three-tiles-carousel__slide--entering');
      setSlideProgress(nextSlide, (previousIndex + 1) / slides.length, true);

      updateThumbnails();
      updateCurrentLabel();
      syncVideos(true);

      function completeTransition() {
        previousSlide.hidden = true;
        if (previousPanel) previousPanel.style.visibility = '';
        previousSlide.classList.remove('ls-three-tiles-carousel__slide--leaving');
        nextSlide.classList.remove(
          'ls-three-tiles-carousel__slide--entering',
          'ls-three-tiles-carousel__slide--visible'
        );
        if (thumbnailsPlaceholder) thumbnailsPlaceholder.remove();
        isTransitioning = false;

        var requestedIndex = queuedIndex;
        queuedIndex = null;
        if (requestedIndex !== null && requestedIndex !== currentIndex) render(requestedIndex);
      }

      if (duration === 0) {
        setSlideProgress(nextSlide, (currentIndex + 1) / slides.length, true);
        completeTransition();
        return;
      }

      transitionFrame = window.requestAnimationFrame(function () {
        transitionFrame = 0;
        transitionInnerFrame = window.requestAnimationFrame(function () {
          transitionInnerFrame = 0;
          nextSlide.classList.add('ls-three-tiles-carousel__slide--visible');
          previousSlide.classList.add('ls-three-tiles-carousel__slide--leaving');
          setSlideProgress(nextSlide, (currentIndex + 1) / slides.length, false);
          transitionTimer = window.setTimeout(function () {
            transitionTimer = 0;
            completeTransition();
          }, duration);
        });
      });
    }

    function navigateBy(offset) {
      var baseIndex = queuedIndex === null ? currentIndex : queuedIndex;
      render(baseIndex + offset);
    }

    previousButtons.forEach(function (button) {
      listen(button, 'click', function () {
        navigateBy(-1);
      });
    });

    nextButtons.forEach(function (button) {
      listen(button, 'click', function () {
        navigateBy(1);
      });
    });

    thumbnails.forEach(function (thumbnail) {
      listen(thumbnail, 'click', function () {
        render(Number(thumbnail.dataset.slideIndex));
      });
    });

    // Mobile swipe. The thumbnails track scrolls horizontally on its own, so a swipe
    // starting inside it must not also change slide.
    function handleTouchStart(event) {
      if (!mobileQuery.matches || slides.length <= 1 || event.touches.length !== 1) return;
      if (event.target.closest('a, button, .ls-three-tiles-carousel__thumbnails')) return;

      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      isTrackingSwipe = true;
    }

    function handleTouchEnd(event) {
      if (!isTrackingSwipe || !event.changedTouches.length) return;

      var horizontalDistance = event.changedTouches[0].clientX - touchStartX;
      var verticalDistance = event.changedTouches[0].clientY - touchStartY;
      isTrackingSwipe = false;

      if (Math.abs(horizontalDistance) < 50 || Math.abs(horizontalDistance) <= Math.abs(verticalDistance)) return;

      if (event.cancelable) event.preventDefault();
      navigateBy(horizontalDistance < 0 ? 1 : -1);
    }

    function handleTouchCancel() {
      isTrackingSwipe = false;
    }

    listen(section, 'touchstart', handleTouchStart, { passive: true });
    listen(section, 'touchend', handleTouchEnd, { passive: false });
    listen(section, 'touchcancel', handleTouchCancel, { passive: true });

    section.querySelectorAll('.ls-three-tiles-carousel__video').forEach(function (video) {
      listen(video, 'loadedmetadata', function () {
        if (video.dataset.lsThreeTilesReset === 'true') {
          video.currentTime = 0;
          delete video.dataset.lsThreeTilesReset;
        }
      });
    });

    function handleMobileChange() {
      updateThumbnails();
      syncVideos(true);
    }

    listenToMediaQuery(mobileQuery, handleMobileChange);

      render(0);

      carouselCleanups.set(section, function () {
        eventCleanups.forEach(function (cleanup) {
          cleanup();
        });
        if (transitionFrame) {
          window.cancelAnimationFrame(transitionFrame);
        }
        if (transitionInnerFrame) {
          window.cancelAnimationFrame(transitionInnerFrame);
        }
        if (transitionTimer) {
          window.clearTimeout(transitionTimer);
        }

        section.querySelectorAll('.ls-three-tiles-carousel__video').forEach(function (video) {
          video.pause();
        });

        section.querySelectorAll('.ls-three-tiles-carousel__thumbnails--placeholder').forEach(function (placeholder) {
          placeholder.remove();
        });
        slides.forEach(function (slide) {
          var panel = slide.querySelector('.ls-three-tiles-carousel__panel');
          if (panel) panel.style.visibility = '';
          slide.classList.remove(
            'ls-three-tiles-carousel__slide--entering',
            'ls-three-tiles-carousel__slide--leaving',
            'ls-three-tiles-carousel__slide--visible'
          );
        });

        section.removeAttribute('data-ls-three-tiles-ready');
        carouselCleanups.delete(section);
      });
    }

    function cleanupCarousel(section) {
      var cleanup = carouselCleanups.get(section);
      if (cleanup) cleanup();
    }

    function initializeCarousels(root) {
      if (!root) return;

      if (root.nodeType === 1 && root.matches('[data-ls-three-tiles-carousel]')) {
        initializeCarousel(root);
      }

      if (typeof root.querySelectorAll === 'function') {
        root.querySelectorAll('[data-ls-three-tiles-carousel]').forEach(function (section) {
          initializeCarousel(section);
        });
      }
    }

    function cleanupCarousels(root) {
      if (!root) return;

      if (root.nodeType === 1 && root.matches('[data-ls-three-tiles-carousel]')) {
        cleanupCarousel(root);
      }

      if (typeof root.querySelectorAll === 'function') {
        root.querySelectorAll('[data-ls-three-tiles-carousel]').forEach(cleanupCarousel);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeCarousels(document);
      });
    } else {
      initializeCarousels(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeCarousels(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      cleanupCarousels(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-turntable-product-category"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // The page-wide "Pause videos" in oa-a11y-controls.js, which may load after this runs.
    function motionPaused() {
      return !!(window.oaA11yControls && window.oaA11yControls.motion.paused());
    }

    function initializeTurntable(section) {
      if (!section || section.dataset.lsTurntableReady === 'true') return;
      section.dataset.lsTurntableReady = 'true';

      var backgrounds = Array.prototype.slice.call(section.querySelectorAll('[data-ls-turntable-background]'));
      var menuItems = Array.prototype.slice.call(section.querySelectorAll('[data-ls-turntable-menu]'));
      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-ls-turntable-card]'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('[data-ls-turntable-panel]'));
      var currentLabel = section.querySelector('[data-ls-turntable-current]');
      var previousButton = section.querySelector('[data-ls-turntable-previous]');
      var nextButton = section.querySelector('[data-ls-turntable-next]');
      var pauseButton = section.querySelector('[data-ls-turntable-pause]');
      var desktopQuery = window.matchMedia('(min-width: 1024px)');
      var currentIndex = 0;
      var isPaused = motionPaused();
      var preloadTimer = null;
      var hasPreloadedAdjacent = false;
      var isPrepared = false;
      var isOnScreen = false;
      var prepareObserver = null;
      var playbackObserver = null;
      var touchStartX = 0;
      var touchStartY = 0;
      var isTrackingSwipe = false;

      if (!backgrounds.length) return;

      function paddedNumber(number) {
        return number < 10 ? '0' + number : String(number);
      }

      function videoForIndex(index) {
        var background = backgrounds[index];
        if (!background) return null;

        var device = desktopQuery.matches ? 'desktop' : 'mobile';
        var selector = '.ls-turntable-product-category__background-video--' + device;
        var video = background.querySelector(selector);

        if (video) return video;

        var template = background.querySelector('[data-ls-turntable-video-template="' + device + '"]');
        if (!template) return null;

        var videoFragment = template.content.cloneNode(true);
        video = videoFragment.querySelector(selector);
        template.replaceWith(videoFragment);

        if (video) {
          // The muted attribute survives cloning, but the property is what autoplay is judged on.
          video.muted = true;
          window.lsApplyHlsSource(video, syncVideos);
        }

        return video;
      }

      function activeVideo() {
        return videoForIndex(currentIndex);
      }

      // Metadata only — the backgrounds are large progressive files, so `auto` would pull
      // tens of MB per slide in the background. play() buffers the rest when it's needed.
      function bufferVideo(video) {
        if (!video || video.dataset.lsTurntableBuffered === 'true') return;

        video.dataset.lsTurntableBuffered = 'true';
        video.preload = 'metadata';
        video.load();
      }

      function preloadAdjacentVideos() {
        if (backgrounds.length <= 1 || !isPrepared) return;
        hasPreloadedAdjacent = true;

        var adjacentIndexes = [
          (currentIndex + 1) % backgrounds.length,
          (currentIndex - 1 + backgrounds.length) % backgrounds.length
        ];

        adjacentIndexes.forEach(function (index, position) {
          if (position > 0 && index === adjacentIndexes[0]) return;
          bufferVideo(videoForIndex(index));
        });
      }

      function scheduleAdjacentVideoPreload() {
        if (!isPrepared) return;
        if (preloadTimer !== null) window.clearTimeout(preloadTimer);

        // Hold the first round back so adjacent-slide video doesn't take bandwidth from
        // the visible background and spotlight images. Later slide changes preload at once.
        var delay = hasPreloadedAdjacent ? 0 : 1500;

        preloadTimer = window.setTimeout(function () {
          preloadTimer = null;
          preloadAdjacentVideos();
        }, delay);
      }

      function syncVideos() {
        var videoToPlay = null;

        if (isPrepared) {
          videoToPlay = activeVideo();
          bufferVideo(videoToPlay);
        }

        section.querySelectorAll('.ls-turntable-product-category__background-video').forEach(function (video) {
          if (video === videoToPlay && isOnScreen && !isPaused) {
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
          } else {
            video.pause();
          }
        });

        if (pauseButton) {
          pauseButton.hidden = !videoToPlay;
          pauseButton.classList.toggle('ls-turntable-product-category__pause--paused', isPaused);
          pauseButton.setAttribute('aria-label', isPaused ? pauseButton.dataset.labelPlay : pauseButton.dataset.labelPause);
        }
      }

      function render(nextIndex) {
        currentIndex = (nextIndex + backgrounds.length) % backgrounds.length;
        isPaused = motionPaused();

        backgrounds.forEach(function (background, index) {
          background.classList.toggle('ls-turntable-product-category__background--active', index === currentIndex);
        });

        menuItems.forEach(function (menuItem, index) {
          var active = index === currentIndex;
          menuItem.classList.toggle('ls-turntable-product-category__menu-item--active', active);
          menuItem.setAttribute('aria-selected', active ? 'true' : 'false');
          menuItem.setAttribute('tabindex', active ? '0' : '-1');
        });

        panels.forEach(function (panel, index) {
          var active = index === currentIndex;
          panel.classList.toggle('ls-turntable-product-category__panel--active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        cards.forEach(function (card, index) {
          var distance = (index - currentIndex + cards.length) % cards.length;
          var position = 'hidden';

          if (distance === 0) position = 'active';
          if (distance === 1) position = 'next';
          if (distance === 2) position = 'far';

          card.dataset.cardPosition = position;
        });

        if (currentLabel) currentLabel.textContent = paddedNumber(currentIndex + 1);
        syncVideos();
        scheduleAdjacentVideoPreload();
      }

      menuItems.forEach(function (menuItem) {
        menuItem.addEventListener('click', function () {
          render(Number(menuItem.dataset.slideIndex));
        });
      });

      // On the tablist, not each tab: audit tools send the arrow key to the tablist itself.
      var menu = section.querySelector('[role="tablist"]');
      if (menu) {
        menu.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            event.preventDefault();
            render(currentIndex - 1);
            menuItems[currentIndex].focus();
          }

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            event.preventDefault();
            render(currentIndex + 1);
            menuItems[currentIndex].focus();
          }
        });
      }

      if (previousButton) {
        previousButton.addEventListener('click', function () {
          render(currentIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          render(currentIndex + 1);
        });
      }

      function handleTouchStart(event) {
        if (backgrounds.length <= 1 || event.touches.length !== 1) return;
        if (event.target.closest('a, button')) return;

        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        isTrackingSwipe = true;
      }

      function handleTouchEnd(event) {
        if (!isTrackingSwipe || !event.changedTouches.length) return;

        var horizontalDistance = event.changedTouches[0].clientX - touchStartX;
        var verticalDistance = event.changedTouches[0].clientY - touchStartY;
        isTrackingSwipe = false;

        if (Math.abs(horizontalDistance) < 50 || Math.abs(horizontalDistance) <= Math.abs(verticalDistance)) return;

        if (event.cancelable) event.preventDefault();
        render(horizontalDistance < 0 ? currentIndex + 1 : currentIndex - 1);
      }

      function handleTouchCancel() {
        isTrackingSwipe = false;
      }

      section.addEventListener('touchstart', handleTouchStart, { passive: true });
      section.addEventListener('touchend', handleTouchEnd, { passive: false });
      section.addEventListener('touchcancel', handleTouchCancel, { passive: true });

      if (pauseButton) {
        pauseButton.addEventListener('click', function () {
          isPaused = !isPaused;
          if (!isPaused && window.oaA11yControls) window.oaA11yControls.motion.release(activeVideo());
          syncVideos();
        });
      }

      function handleMotionChange(event) {
        isPaused = event.detail.paused;
        syncVideos();
      }

      document.addEventListener('oa:motionchange', handleMotionChange);

      function handleBreakpointChange() {
        isPaused = motionPaused();
        syncVideos();
        scheduleAdjacentVideoPreload();
      }

      if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', handleBreakpointChange);
      } else if (typeof desktopQuery.addListener === 'function') {
        desktopQuery.addListener(handleBreakpointChange);
      }

      function handleVisibilityChange() {
        if (document.hidden) {
          section.querySelectorAll('.ls-turntable-product-category__background-video').forEach(function (video) {
            video.pause();
          });
        } else {
          syncVideos();
        }
      }

      document.addEventListener('visibilitychange', handleVisibilityChange);

      section.lsTurntableDestroy = function () {
        if (preloadTimer !== null) window.clearTimeout(preloadTimer);
        if (prepareObserver) prepareObserver.disconnect();
        if (playbackObserver) playbackObserver.disconnect();

        if (typeof desktopQuery.removeEventListener === 'function') {
          desktopQuery.removeEventListener('change', handleBreakpointChange);
        } else if (typeof desktopQuery.removeListener === 'function') {
          desktopQuery.removeListener(handleBreakpointChange);
        }

        document.removeEventListener('visibilitychange', handleVisibilityChange);
        document.removeEventListener('oa:motionchange', handleMotionChange);
        section.removeEventListener('touchstart', handleTouchStart);
        section.removeEventListener('touchend', handleTouchEnd);
        section.removeEventListener('touchcancel', handleTouchCancel);
        section.querySelectorAll('.ls-turntable-product-category__background-video').forEach(function (video) {
          video.pause();
        });
        delete section.dataset.lsTurntableReady;
        delete section.lsTurntableDestroy;
      };

      render(0);

      // Two stages: hydrate and fetch metadata roughly two viewports out, but hold playback
      // until the section is actually on screen so it never buffers behind the fold.
      if (typeof IntersectionObserver === 'function') {
        prepareObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            isPrepared = true;
            syncVideos();
            scheduleAdjacentVideoPreload();
          });
        }, { rootMargin: '200% 0px' });

        playbackObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            isOnScreen = entry.isIntersecting;
            syncVideos();
          });
        });

        prepareObserver.observe(section);
        playbackObserver.observe(section);
      } else {
        isPrepared = true;
        isOnScreen = true;
        syncVideos();
        scheduleAdjacentVideoPreload();
      }
    }

    function initializeTurntables(root) {
      if (!root) return;

      if (root.nodeType === 1 && root.matches('[data-ls-turntable]')) {
        initializeTurntable(root);
      }

      if (typeof root.querySelectorAll === 'function') {
        root.querySelectorAll('[data-ls-turntable]').forEach(function (section) {
          initializeTurntable(section);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeTurntables(document);
      });
    } else {
      initializeTurntables(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeTurntables(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var section = event.target.matches('[data-ls-turntable]')
        ? event.target
        : event.target.querySelector('[data-ls-turntable]');

      if (section && typeof section.lsTurntableDestroy === 'function') {
        section.lsTurntableDestroy();
      }
    });

    document.addEventListener('shopify:block:select', function (event) {
      var selector = '[data-block-id="' + event.detail.blockId + '"]';
      var panel = event.target.matches(selector) ? event.target : event.target.querySelector(selector);
      if (!panel) return;

      var section = panel.closest('[data-ls-turntable]');
      var menuItem = section && section.querySelector('[data-ls-turntable-menu][data-slide-index="' + panel.dataset.slideIndex + '"]');
      if (menuItem) menuItem.click();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
